import SalesActionBar from '../Toolbar/SalesActionBar';

const POSQuickActions = () => {
  return (
    <div className="flex flex-col gap-4">

      {/* ===================================================== */}
      {/* 🔹 Actions */}
      {/* ===================================================== */}
      <div
        className="
          flex
          flex-wrap
          gap-3
        "
      >
        <SalesActionBar />
      </div>
    </div>
  );
};

export default POSQuickActions;